import React, { useState, useEffect, useCallback } from 'react';

const HeroCarousel = ({ images = [] }) => {
  const [current, setCurrent] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  const goTo = useCallback((index) => {
    if (transitioning || index === current) return;
    setTransitioning(true);
    setTimeout(() => {
      setCurrent(index);
      setTransitioning(false);
    }, 400);
  }, [current, transitioning]);

  const next = useCallback(() => {
    goTo((current + 1) % images.length);
  }, [current, images.length, goTo]);

  const prev = useCallback(() => {
    goTo((current - 1 + images.length) % images.length);
  }, [current, images.length, goTo]);

  useEffect(() => {
    if (images.length <= 1) return;
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next, images.length]);

  if (!images || images.length === 0) return null;

  return (
    <div className="relative w-full overflow-hidden bg-gray-900" style={{ height: '520px' }}>
      {/* Slides */}
      {images.map((src, i) => (
        <div
          key={i}
          className="absolute inset-0 transition-opacity duration-700"
          style={{ opacity: i === current ? 1 : 0, zIndex: i === current ? 1 : 0 }}
        >
          <img
            src={src}
            alt={`Hero ${i + 1}`}
            className="w-full h-full object-cover"
          />
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black" style={{ opacity: 0.35 }} />
        </div>
      ))}

      {/* Center text overlay */}
      <div className="absolute inset-0 flex flex-col items-center justify-center z-10 px-4 text-center">
        <h1 className="text-white font-bold drop-shadow-lg"
          style={{ fontSize: 'clamp(1.8rem, 4vw, 3rem)', lineHeight: 1.2, textShadow: '0 2px 12px rgba(0,0,0,0.6)' }}>
          As melhores máquinas do mercado
        </h1>
        <p className="text-gray-200 mt-4 drop-shadow"
          style={{ fontSize: 'clamp(1rem, 2vw, 1.3rem)', textShadow: '0 1px 8px rgba(0,0,0,0.7)', maxWidth: '600px' }}>
          Somos especializados na comercialização de máquinas industriais
        </p>
        <a
          href="#catalogo"
          className="mt-8 inline-block bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-colors"
          style={{ padding: '0.85rem 2.5rem', fontSize: '1.05rem' }}
        >
          Ver Catálogo
        </a>
      </div>

      {/* Arrows */}
      {images.length > 1 && (
        <>
          <button
            onClick={prev}
            className="absolute left-4 top-1/2 -translate-y-1/2 z-20 flex items-center justify-center rounded-full bg-black bg-opacity-40 hover:bg-opacity-70 text-white transition-all"
            style={{ width: '44px', height: '44px', fontSize: '1.4rem' }}
            aria-label="Anterior"
          >
            ‹
          </button>
          <button
            onClick={next}
            className="absolute right-4 top-1/2 -translate-y-1/2 z-20 flex items-center justify-center rounded-full bg-black bg-opacity-40 hover:bg-opacity-70 text-white transition-all"
            style={{ width: '44px', height: '44px', fontSize: '1.4rem' }}
            aria-label="Próximo"
          >
            ›
          </button>
        </>
      )}

      {/* Dots */}
      {images.length > 1 && (
        <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-20 flex gap-2">
          {images.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className="rounded-full transition-all"
              style={{
                width: i === current ? '28px' : '10px',
                height: '10px',
                background: i === current ? '#f97316' : 'rgba(255,255,255,0.6)',
              }}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default HeroCarousel;
